const firebaseConfig = {
    apiKey: "AIzaSyACSgfNConUDZkKEyTmx8eEhuEzl8c0n2E",
    authDomain: "twitter-react-c15b9.firebaseapp.com",
    projectId: "twitter-react-c15b9",
    storageBucket: "twitter-react-c15b9.firebasestorage.app",
    messagingSenderId: "1077379112162",
    appId: "1:1077379112162:web:c8f50792319a40874752bb"
  };

  export default firebaseConfig;